module.exports = __webpack_public_path__ + "img/hyu_gallery12.3641f103.jpg";